import { render } from "./confirmcration.vue?vue&type=template&id=6bf4ab36&scoped=true"
import script from "./confirmcration.vue?vue&type=script&lang=js"
export * from "./confirmcration.vue?vue&type=script&lang=js"

import "./confirmcration.vue?vue&type=style&index=0&id=6bf4ab36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf4ab36"]])

export default __exports__